const getMonday = (date: Date): Date => {
  const day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday

  return new Date(new Date(date.setDate(diff)).setHours(0, 0, 0, 0));
};
export default getMonday;
